module.exports = {
	name: 'Obari - Obari web app',
	shortName: 'Obari',
	description: 'Obari portal version of the mobile app',
	primaryColor: '#253c99',
	secondaryColor: '#13a689',
	msTileColor: '#253c99'
}